/* eslint-disable @typescript-eslint/no-use-before-define */

import { DateEntry } from '../Types/DateEntry';
import { MonthEntry } from '../Types/MonthEntry';
import * as dateFunctions from '@Functions/DateFunctions';
import AvailabilityFetchVM from '../Types/AvailabilityFetchTSVM';


/**
 * Creates all basic months/days for the given range.
 * 
 * @param startYear
 * @param startMonth
 * @param endYear
 * @param endMonth
 */
export default function createData(startYear: number, startMonth: number, endYear: number, endMonth: number, aval: AvailabilityFetchVM | undefined): Array<MonthEntry> {


    const result = new Array<MonthEntry>();

    // starting with startYear, until endMonth, create months

    let doNextMonth = true;
    let index = 0;

    while (doNextMonth) {

        index++;
        if (index > 10 * 12) break; // hard cap for 10 years currently.

        const month = new MonthEntry(startMonth, startYear);
        createDaysForMonth(month, aval); //eslint-disable-line


        result.push(month);

        startMonth++;
        if (startMonth > 11) {
            startMonth = 0;
            startYear++;
        }

        if (startYear === endYear && startMonth > endMonth) {

            doNextMonth = false;
        }
    }




    return result;
}


function createDaysForMonth(month: MonthEntry, aval: AvailabilityFetchVM | undefined) {


    month.days = new Array<DateEntry>();

    const firstDayDate = new Date(month.year, month.month, 1);
    const lastDayDate = new Date(month.year, month.month + 1, 0);


  
    // add days of previous month if needed
    const daysInPrevMonth = dateFunctions.computeNrOfDaysInPreviousMonth(firstDayDate.getDay());

    if (daysInPrevMonth > 0) {

        // determine what the actual dates are:
        const prevDate = new Date(firstDayDate.valueOf());
        prevDate.setDate(prevDate.getDate() - daysInPrevMonth);

        // foreach day in prev month, add day
        for (let i = 0; i < daysInPrevMonth; i++) {

            month.days.push(createAndFillDataEntry(aval, prevDate.getDate() + i, prevDate.getMonth(), prevDate.getFullYear(), true, false)); 
        }
    }

    // add each day of the month
    for (let i = 1; i <= lastDayDate.getDate(); i++) {

        month.days.push(createAndFillDataEntry(aval, i, month.month, month.year));
    }

    // add days in next month, if any
    const daysInNextMonth = dateFunctions.computeNrOfDaysInNextMonth(lastDayDate.getDay());

    if (daysInNextMonth > 0) {

        const nextDate = new Date(lastDayDate.valueOf());
        nextDate.setDate(nextDate.getDate() + 1);

        // foreach day in next month, add day
        for (let i = 1; i <= daysInNextMonth; i++) {

            month.days.push(createAndFillDataEntry(aval, i, nextDate.getMonth(), nextDate.getFullYear(), false, true));
        }
    }

}



function createAndFillDataEntry(aval: AvailabilityFetchVM | undefined, day: number, month: number, year: number, isPrevious = false, isNext = false): DateEntry {

    const entry = new DateEntry(day, month, year);
    entry.updateForAvailability(aval);

    if (isNext) {
        entry.classes.push("next");
    }
    if (isPrevious) {
        entry.classes.push("prev");
    }

    return entry;

}

